// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__VYZUA","bounce":"Modal_bounce__P6351","overlay":"Modal_overlay__PiZY2","Wrapper":"Modal_Wrapper__XMSDB"};